// TODO: LK Update with new color themes after receiving update UI preference from StoneAge.

/**
 * Themed colors used through out the application
 * @deprecated
 */
const AppColors = {
  Primary: '#A95E27',
  Black: '#212121',
  Tan: '#E6DAC4',
  LightBrown: '#9C8061',
  DarkBrown: '#9D5F31',
  DarkGray: '#757575',
  UltraDarkGray: '#2C2c2c',
  White: '#FFFFFF',
  LightGray: '#EEEEEE',
  UltraLightGray: '#F6F6F6',
  Blue: '#51A0D5',
  LightBlue: '#CCE3FF',
  Gray: '8c8c8c',
  BlueGray: '7384aa',
  Green: '#4CAF50',
  Yellow: '#FFCC00',
  OpaqueBlack: 'rgba(33, 33, 33, 0.9)',
  Red: '#CC1111',
  LightOrange: '#FBAA0E',
  MediumGray: '#999999',
};

export default AppColors;
